@if (option(); as option) {
  @if (pricePreview(); as preview) {
    @if (preview.calculation; as calculation) {
      <div class="flex flex-column m-t-24 md:m-0 text-md">
        <h3 class="heading-sm m-b-12 md:m-b-0">Preview</h3>
        <div class="flex flex-column gap-20">
          <ul
            role="list"
            aria-label="Price breakdown"
            class="flex flex-column gap-16"
          >
            <hr class="w-100 m-t-12 m-b-2" />
            <li role="listitem" class="flex flex-justify-between">
              <span>{{ optionName() }}</span>
              <span>{{
                calculation.basePrice | price: calculation.currency
              }}</span>
            </li>
            @for (discount of calculation.discounts; track $index) {
              <li role="listitem" class="flex flex-justify-between">
                <span
                  >{{ discount.name
                  }}{{ discount.label ? '(' + discount.label + ')' : '' }}</span
                >
                <span
                  >&minus;{{
                    discount.value | price: calculation.currency
                  }}</span
                >
              </li>
            }
            @for (item of calculation.taxItems; track $index) {
              <li role="listitem" class="flex flex-justify-between">
                <span>
                  {{ item.type }}{{ formatRate(item.rate)
                  }}{{ item.inclusive ? ' incl.' : '' }}
                </span>
                <span>{{ item.taxAmount | price: calculation.currency }}</span>
              </li>
            }
            <hr class="w-100 m-y-2" />
            <li role="listitem" class="flex flex-justify-between">
              <strong>To be paid</strong>
              <strong class="text-lg">{{
                calculation.amountTotal | price: calculation.currency
              }}</strong>
            </li>
            <hr class="w-100 m-y-2" />
          </ul>
        </div>
        <ng-container
          *ngTemplateOutlet="subscriptionOptionInformation"
        ></ng-container>
        <footer>
          <yo-button
            type="submit"
            role="primary"
            size="medium"
            class="flex flex-justify-center m-t-16"
            [disabled]="processingPayment()"
            [loading]="processingPayment()"
            (click)="
              buyOrPreviewOption(preview.params[0], preview.params[1], true)
            "
            >{{
              optionHasTrial() ? 'Start free trial now' : 'Confirm Purchase'
            }}</yo-button
          >
        </footer>
      </div>
    }
  } @else {
    <joymo-capture-payment-method
      *ngIf="option"
      [title]="title"
      confirmButtonLabel="Next"
      [option]="{ option: option, additionalConfig: additionalConfig() }"
      (onPaymentDetailsCaptured)="buyOrPreviewOption($event, option)"
      (onPriceEstimateAvailable)="onPriceEstimateAvailable($event)"
    >
    </joymo-capture-payment-method>
  }
}

<ng-template #subscriptionOptionInformation>
  @if (subscriptionInfo(); as info) {
    <div class="p-t-24 p-b-16 flex flex-column gap-8" style="max-width: 572px">
      @if (info.emphasized) {
        @for (emp of info.emphasized; track $index) {
          <strong>{{ emp }}</strong>
        }
      }
      @for (text of info.body; track $index) {
        <p>{{ text }}</p>
      }
      @if (info.canCancelAnytime) {
        Cancel anytime.
      }
    </div>
  }
</ng-template>
